import { Link, useLocation, useSearchParams } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export default function Unauthorized() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  // Email can arrive via router state (SPA nav) or query (server redirect from Google OAuth)
  const email = location.state?.email || searchParams.get("email") || null;

  return (
    <div
      data-testid="page-unauthorized"
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "#FAF6EC" }}
    >
      <div
        className="max-w-md w-full rounded-2xl border p-10 text-center"
        style={{ background: "#fff", borderColor: "rgba(27,67,50,0.15)" }}
      >
        <div
          className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full"
          style={{ background: "#FAF6EC", color: "#1B4332", border: "1px solid rgba(201,168,76,0.5)" }}
        >
          <ShieldAlert size={22} />
        </div>
        <h1 className="font-serif text-3xl mt-5" style={{ color: "#1B4332" }}>
          You&rsquo;re not on the guest list.
        </h1>
        <p className="mt-3 text-sm" style={{ color: "#2A2621" }}>
          {email ? (
            <>
              <span className="font-medium">{email}</span> isn&rsquo;t on the admin allowlist. If
              that&rsquo;s a mistake, ask Priya to add you.
            </>
          ) : (
            <>This Google account isn&rsquo;t on the admin allowlist.</>
          )}
        </p>
        <div className="mt-8 flex flex-col gap-3">
          <Link to="/admin/login" className="btn-outline-forest" data-testid="unauth-back-signin">
            Try a different account
          </Link>
          <Link to="/" className="text-sm underline" style={{ color: "#1B4332" }} data-testid="unauth-back-home">
            Back to the site
          </Link>
        </div>
      </div>
    </div>
  );
}
